import { createSlice } from "@reduxjs/toolkit"
import { getTagList } from "../../app/services/tag"
import { getAgentInfo, getTagInfo, getBrandList, getSourceList, getCaseStatusList } from "./homeActions"


const initialState = {
    active_chat: '',
    socket_status : 'idle', // idle ,connected, disconnected
    agentInfo: {
        data: null,
        status: 'idle'
    },
    tagOptions: {
        data: null,
        status: 'idle'
    },
    brandOptions: {
        data: null,
        status: 'idle'
    },
    sourceOptions: {
        data: null,
        status: 'idle'
    },
    caseStatusOptions: {
        data: null,
        status: 'idle'
    }
}

export const homeSlice = createSlice({
    name: 'home',
    initialState,
    reducers: {
        setActiveChat: (state, action) => {
            state.active_chat = action.payload
        },
        setSocketStatus: (state, action) => {
            state.socket_status = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getTagInfo.pending, (state) => {
            state.tagOptions.status = 'pending'
        })
        builder.addCase(getTagInfo.fulfilled, (state, action) => {
            state.tagOptions.status = 'fulfilled'
            state.tagOptions.data = action.payload
        })
        builder.addCase(getTagInfo.rejected, (state, action) => {
            state.tagOptions.status = 'rejected'
        })

        builder.addCase(getAgentInfo.pending, (state) => {
            state.agentInfo.status = 'pending'
        })
        builder.addCase(getAgentInfo.fulfilled, (state, action) => {
            state.agentInfo.status = 'fulfilled'
            state.agentInfo.data = action.payload
        })
        builder.addCase(getAgentInfo.rejected, (state, action) => {
            state.agentInfo.status = 'rejected'
        })

        builder.addCase(getBrandList.pending, (state) => {
            state.brandOptions.status = 'pending'
        })
        builder.addCase(getBrandList.fulfilled, (state, action) => {
            state.brandOptions.status = 'fulfilled'
            state.brandOptions.data = action.payload
        })
        builder.addCase(getBrandList.rejected, (state, action) => {
            state.brandOptions.status = 'rejected'
        })

        builder.addCase(getSourceList.pending, (state) => {
            state.sourceOptions.status = 'pending'
        })
        builder.addCase(getSourceList.fulfilled, (state, action) => {
            state.sourceOptions.status = 'fulfilled'
            state.sourceOptions.data = action.payload
        })
        builder.addCase(getSourceList.rejected, (state, action) => {
            state.sourceOptions.status = 'rejected'
        })

        builder.addCase(getCaseStatusList.pending, (state) => {
            state.caseStatusOptions.status = 'pending'
        })
        builder.addCase(getCaseStatusList.fulfilled, (state, action) => {
            state.caseStatusOptions.status = 'fulfilled'
            state.caseStatusOptions.data = action.payload
        })
        builder.addCase(getCaseStatusList.rejected, (state, action) => {
            state.caseStatusOptions.status = 'rejected'
        })
    }
})

export const { setActiveChat, setSocketStatus } = homeSlice.actions
export const selectActiveChat = (store) => store.home.active_chat
export const selectSocketStatus = (store) => store.home.socket_status
export const selectAgentInfo = (store) => store.home.agentInfo
export const selectTagOptions = (store) => store.home.tagOptions.data
export const selectBrandOptions = (store) => store.home.brandOptions.data
export const selectSourceOptions = (store) => store.home.sourceOptions.data
export const selectCaseStatusOptions = (store) => store.home.caseStatusOptions.data
export default homeSlice.reducer